import React from 'react';
import { Route, Switch } from "react-router-dom";
import AllSurahView from './AllSurahView';
import TafsirSurahMain from "./TafsirSurahMain";
import TafsirSurahTafsirViewer from "./TafsirSurahTafsirViewer";

const TafsirRoutes = () => (
    <Switch>
      <Route exact path="/tafsir" component={AllSurahView}/>
      <Route exact path="/tafsir/:surahNumber" component={TafsirSurahMain}/>
      <Route exact path="/tafsir/:surahNumber/:tafsirNumber" component={TafsirSurahTafsirViewer}/>
      <Route component={AllSurahView} />
    </Switch>
  )
  export default TafsirRoutes;